// Algolia Advanced customization - Custom Hooks

document.addEventListener('algolia.hooks.initialize', function() {
 
// Autocomplete hooks - begin
  
  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    options.placeholder = "Search";
    options.openOnFocus = true;
    options.detachedMediaQuery = 'none';
    options.onStateChange = function({ state }) {
      if(state.query === ""){
       document.body.classList.add("search-no-query");
       // console.log('empty query');
      }else{
       document.body.classList.remove("search-no-query");
       // console.log(state.query); 
      }
    };
  
    return options;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteSuggestionsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, item, state, components } = templateOptions;
    return html`
      <a
        class="aa-ItemLink aa-ItemWrapper"
        href="${window.Shopify.routes.root}search?q=${item.query}"
      >
        <div class="aa-ItemContent">
          <div class="aa-ItemIcon aa-ItemIcon--noBorder">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z" />
            </svg>
          </div>
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: 'query' })}
            </div>
          </div>
        </div>
        <div class="aa-ItemActions">
          <button
            class="aa-ItemActionButton"
            title={"Fill query with ${item.query}"}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 17v-7.586l8.293 8.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-8.293-8.293h7.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-10c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1s1-0.448 1-1z" />
            </svg>
          </button>
        </div>
      </a>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function(_defaultTemplate, templateOptions, resource) {
    const { html, state } = templateOptions;

function customRenderTitle(resource) {
  // console.log('Resource:', resource);
  if (resource === 'Collections') {
    return 'Trending Collections';
  } else if (resource === 'Articles') {
    return 'The RMS Blog';
  } else if (resource === 'Pages') {
    return 'RMS Corner';
  }else if (resource === 'Products') {
    return 'Best Sellers';
  }
  
  return resource.title || resource.name || 'Default Title';
}
    
    return html`
      <div class="aa-SourceHeader">
        <span class="aa-SourceHeaderTitle">
        ${customRenderTitle(resource)}
        </span>
        <div class="aa-SourceHeaderLine" />
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteNoResultsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable aa-Panel--NoResults">
        <p class="aa-NoResultsHeader">
          ${algoliaShopify.translation_helpers.no_result_for(state.query)}
        </p>
        <a class="aa-NoResultsLink" href="${window.Shopify.routes.root}search?q=">
          ${algoliaShopify.translations.allProducts}
        </a>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html } = templateOptions;
    // Don't return the default template and return a custom two-column layout instead
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSections">
          <div class="aa-PanelSection--left">
            ${displaySuggestions &&
              html`
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle">
                  Popular Searches
                  </span>
                  <div class="aa-SourceHeaderLine" />
                </div>
                ${elements.querySuggestionsPlugin}
              `}
            ${elements.collections} ${elements.articles} ${elements.pages}
            ${elements.redirectUrlPlugin}
          </div>
          <div class="aa-PanelSection--right">

        <section class="aa-PanelSection--quickAccess">
        <div class="aa-SourceHeader">
        <span class="aa-SourceHeaderTitle">RMS Trendsetters</span>
        <div class="aa-SourceHeaderLine"></div>
        </div>

        <ul class="aa-List">
        <li class="aa-Item">
        <a href="/collections/new-products" class="aa-ItemLink aa-QuickAccessItem">
        <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
        <img src="https://cdn.shopify.com/s/files/1/0642/6399/files/AlgoliaSearchHeros-NewArrivals_590x_416c01c5-79d2-452c-99f8-e1068d6707d1.jpg?v=1691429748" alt="New Arrivals" loading="lazy" />
        </div>
        <div class="aa-ItemContentTitle">New Arrivals</div>
        </div>
        </a>
        </li>
        <li class="aa-Item">
        <a href="/collections/now-trending" class="aa-ItemLink aa-QuickAccessItem">
        <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
        <img src="https://cdn.shopify.com/s/files/1/0642/6399/files/AlgoliaSearchHeros-TikTokTrending_590x_46e46f62-957e-4acb-aa25-ddba0ee77935.jpg?v=1691429748" alt="Trending on Tiktok" loading="lazy"/>
        </div>
        <div class="aa-ItemContentTitle">Trending on Tiktok</div>
        </div>
        </a>
        </li>
        <li class="aa-Item">
        <a href="/pages/find-your-rms-match-quiz" class="aa-ItemLink aa-QuickAccessItem">
        <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
        <img src="https://cdn.shopify.com/s/files/1/0642/6399/files/AlgoliaSearchHeros-FindRMSMatch_590x_c3c0ee7b-4ced-4192-811e-1c8d4697b9a9.jpg?v=1691429748" alt="Find your RMS match" loading="lazy"/>
        </div>
        <div class="aa-ItemContentTitle">Find your RMS match</div>
        </div>
        </a>
        </li>
        <li class="aa-Item">
        <a href="/collections/build-your-own-bundle" class="aa-ItemLink aa-QuickAccessItem">
        <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
        <img src="https://cdn.shopify.com/s/files/1/0642/6399/files/Algolia-Navigation-BYOB.jpg?v=1730797256" alt="Bundles" loading="lazy"/>
        </div>
        <div class="aa-ItemContentTitle">Build Clean Beauty Kit</div>
        </div>
        </a>
        </li>
        </ul>
        </section>
        
            ${elements.products}
          </div>
        </div>
      </div>
    `;
  });
  
// Autocomplete Articles Template
  algoliaShopify.hooks.registerHook("beforeAutocompleteArticlesTemplate", function (_defaultTemplate, templateOptions, itemLink) {
      const { item, html, components } = templateOptions;
      return html`
    <a href="${itemLink}" class="aa-ItemLink">
      <div class="aa-ItemWrapper">
        <div class="aa-ItemContent">
          <div class="aa-ItemIcon aa-ItemIcon--noBorder">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 216 216" style="enable-background:new 0 0 216 216;" xml:space="preserve">
<style type="text/css">
    .st0{fill:#FFFFFF;stroke:#000000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
    .st1{fill:none;stroke:#000000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
</style>
<g>
    <path class="st0" d="M134.23,62.05c-3.56,0-85.32,0-85.32,0c-7.68,0-13.9,6.22-13.9,13.9v49.31c0,7.68,6.22,13.9,13.9,13.9h4.77
    c0.99,2.15,2.46,6.11,2.41,11.24c-0.06,6.32-2.39,10.97-3.63,13.09c2.09-0.56,9.21-2.74,14.32-9.84
    c4.32-6.01,4.76-12.16,4.81-14.49c19.59,0,39.19,0,58.78,0c7.68,0,13.9-6.22,13.9-13.9c0,0,0-3.7,0-9.08"/>
    <line class="st1" x1="107.25" y1="85.99" x2="61.75" y2="85.99"/>
    <line class="st1" x1="100.6" y1="101.34" x2="61.75" y2="101.34"/>
    <line class="st1" x1="95.61" y1="116.69" x2="61.75" y2="116.69"/>
    <g>
        <path class="st0" d="M114.67,91.79l42.54-35.94c5.58-4.71,13.85-4.31,18.94,0.92l0,0c5.62,5.77,5.18,15.09-0.96,20.3l-42.07,35.74
        l-26.87,3.88L114.67,91.79z"/>
        <line class="st0" x1="117.02" y1="92.13" x2="133.15" y2="111.23"/>
        <line class="st0" x1="155.76" y1="59.43" x2="171.89" y2="78.53"/>
    </g>
</g>
</svg>
          </div>
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
            </div>
          </div>
        </div>
      </div>
    </a>
  `;
    }
  );

  // Autocomplete Pages Template
  algoliaShopify.hooks.registerHook('beforeAutocompletePagesTemplate', function(_defaultTemplate, templateOptions, itemLink) {
    const { html, item, components } = templateOptions;
    return html`
      <a href="${itemLink}" class="aa-ItemLink aa-ProductItem">
        <div class="aa-ItemWrapper">
          <div class="aa-ItemContent">
            <div class="aa-ItemIcon aa-ItemIcon--noBorder">
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 216 216" style="enable-background:new 0 0 216 216;" xml:space="preserve">
<style type="text/css">
  .st0{fill:#FFFFFF;stroke:#000000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
</style>
<path class="st0" d="M112.7,46.92l16.65,33.74c0.76,1.55,2.24,2.62,3.94,2.87l37.24,5.41c4.3,0.62,6.01,5.9,2.9,8.94l-26.94,26.26
c-1.23,1.2-1.8,2.94-1.51,4.64l6.36,37.09c0.73,4.28-3.76,7.54-7.6,5.52l-33.3-17.51c-1.53-0.8-3.35-0.8-4.88,0l-33.3,17.51
c-3.84,2.02-8.33-1.24-7.6-5.52l6.36-37.09c0.29-1.7-0.27-3.43-1.51-4.64L42.57,97.88c-3.11-3.03-1.39-8.31,2.9-8.94l37.24-5.41
c1.71-0.25,3.18-1.32,3.94-2.87l16.65-33.74C105.22,43.03,110.78,43.03,112.7,46.92z"/>
</svg>
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: 'title' })}
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
  });

// Template for rendering each product hit in the autocomplete results.
algoliaShopify.hooks.registerHook("beforeAutocompleteProductTemplate", function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      
// Modify default options, then return them
const { html, item, components } = templateOptions;
// console.log(item);

// %OFF sale label
if (item.meta && item.meta.custom && item.meta.custom.sale_badge) {
    item.sale_label = `${item.meta.custom.sale_badge} OFF`;
}else if (item.compare_at_price && item.price < item.compare_at_price) {
  // const priceDiff = item.compare_at_price - item.price;
  // const percentDiff = Math.round((priceDiff / item.compare_at_price) * 100);

  const priceDiff = item.compare_at_price - item.price;
  let percentDiff = (priceDiff / item.compare_at_price) * 100;

  const decimalPart = percentDiff - Math.floor(percentDiff);  // Extract the decimal part

  // Apply the rounding logic based on the decimal part
  if (decimalPart < 0.8) {
    percentDiff = Math.floor(percentDiff);  // Round down if the decimal part is less than 0.8
  } else {
    percentDiff = Math.round(percentDiff);   // Round up if the decimal part is greater than or equal to 0.8
  }

  item.sale_label = `${percentDiff}% OFF`;
} else {
  item.sale_label = null;
}
      return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${() => trackSearchAttribution(item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${algoliaShopify.helpers.grandeImage(item)}"
            alt="${item.title}"
          />
          <div class="product--label-container">
          ${item.tags
            .filter(tag => tag.startsWith('label-')) // Filter only the tags that start with "label-"
            .map(tag => html`
                <div class="aa-product-label">${tag.replace('label-','')}</div>
              `)
            }

        <!-- %OFF sale label -->
       ${item.sale_label
        ? html`<div class="aa-product-label product--label_sale_percent">${item.sale_label}</div>`
        : ''}
        </div>
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
          </div>
          <div class="aa-ItemContentPrice">
            <div class="aa-ItemContentPriceCurrent">
              ${algoliaShopify.helpers.displayPrice(item, distinct).includes('-') 
    ? html`
        <span class="product--from" data-item="nav-text">From</span>
        ${algoliaShopify.helpers.displayPrice(item, distinct).split('-')[0].trim()}
      `
    : algoliaShopify.helpers.displayPrice(item, distinct).trim()}
            </div>
          </div>
        </div>
      </div>
    </a>
  `;
    }
  );
  
// Autocomplete hooks - end
  
// InstantSearch hooks - begin

algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {

var i = 0;
if (document.body.classList.contains('template--search')) {

  return html`
      <div class="ais-page">
        <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          Show filters
        </div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          <div class="wrap ${(data.facets && data.facets.length) > 0 ? '' : 'no-facets'}">
          <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    <span class="ais-sort-label">Sort By:</span>
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          
          ${data.facets.map( facet => {
            i++
              var toReturn = html`
                <div
                  class="product-facet__filter-item ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}" data-index="${i}">
                  <button type="button" is="toggle-button" class="collapsible-toggle" aria-controls="${facet.escapedName}">
                  ${facet.title}
                    <svg focusable="false" width="10" height="8" class="icon" viewBox="0 0 12 8">
                    <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
                    </svg>
                    </button>
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <collapsible-content
                  id="${facet.escapedName}"
                   class="collapsible collapsible-${facet.escapedName}"
                   >
                  <div class="collapsible__content ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                  </collapsible-content>
                </div>
              `
            return toReturn;
          }
          )}
          </div>
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  
} else {
  
  return html`
      <div class="ais-page">
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          Show filters
        </div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          <div class="wrap ${(data.facets && data.facets.length) > 0 ? '' : 'no-facets'}">
          <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    <span class="ais-sort-label">Sort By:</span>
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          ${data.facets.map( facet => {
            i++
              var toReturn = html`
                <div
                  class="product-facet__filter-item ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}" data-index="${i}">
                  <button type="button" is="toggle-button" class="collapsible-toggle" aria-controls="${facet.escapedName}">
                  ${facet.title}
                    <svg focusable="false" width="10" height="8" class="icon" viewBox="0 0 12 8">
                    <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
                    </svg>
                    </button>
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <collapsible-content
                  id="${facet.escapedName}"
                   class="collapsible collapsible-${facet.escapedName}"
                   >
                  <div class="collapsible__content ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                  </collapsible-content>
                </div>
              `
            return toReturn;
          }
          )}
          </div>
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
}
    
});

// Product Template - begin
let productCounter = 0;
algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components, trackSearchAttribution) {

  console.log('trackSearchAttribution:', trackSearchAttribution);
//   if (typeof trackSearchAttribution === 'function') {
//       trackSearchAttribution();
//     } else {
//       console.warn('trackSearchAttribution is not available in beforeInstantSearchProductTemplate');
//     }
//   const trackFunction = (query_id, variant_id, product_id) => {
//   trackSearchAttribution(query_id, variant_id, product_id);
// };

  
// Increment the product counter
productCounter++;
// Determine the value of the "loading" attribute
const loadingAttribute = productCounter > 2 ? 'lazy' : 'eager';

// console.log(hit);

// %OFF sale label
if (hit.meta && hit.meta.custom && hit.meta.custom.sale_badge) {
    hit.sale_label = `${hit.meta.custom.sale_badge} OFF`;
} else if (hit.compare_at_price && hit.price < hit.compare_at_price) {
  // const priceDiff = hit.compare_at_price - hit.price;
  // const percentDiff = Math.round((priceDiff / hit.compare_at_price) * 100);

  const priceDiff = hit.compare_at_price - hit.price;
  let percentDiff = (priceDiff / hit.compare_at_price) * 100;

  const decimalPart = percentDiff - Math.floor(percentDiff);  // Extract the decimal part

  // Apply the rounding logic based on the decimal part
  if (decimalPart < 0.8) {
    percentDiff = Math.floor(percentDiff);  // Round down if the decimal part is less than 0.8
  } else {
    percentDiff = Math.round(percentDiff);   // Round up if the decimal part is greater than or equal to 0.8
  }

  hit.sale_label = `${percentDiff}% OFF`;
} else {
  hit.sale_label = null;
}

//CTA option_name
var option_name = 'SHOP NOW';

if (Array.isArray(hit.option_names)) {
  if (hit.option_names.length === 1) {
    option_name = 'CHOOSE ' + hit.option_names[0]; // Display the first option if only one exists
  } else if (hit.option_names.length > 1) {
    option_name = 'CHOOSE OPTIONS';
  }
}
if (hit.handle == 'legendary-lip-lash-kit') {
  option_name = "Choose options";
}
// if (hit.variants_inventory_count <= 0) {
//   option_name = 'OUT OF STOCK';
// }
if (hit.tags && hit.tags.includes('coming-soon')) {
  option_name = 'COMING SOON';
} else if (hit.variants_inventory_count <= 0) {
  option_name = 'OUT OF STOCK';
}

    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onclick="${() => trackSearchAttribution(hit)}"
      >
    <a href="${algoliaShopify.helpers.instantsearchLink(hit)}">
      <div class="ais-ItemContent">
      
      <div class="ais-hit--picture">
        <img
          src="${algoliaShopify.helpers.originalImage(hit)}"
          alt="${hit.title} - ${hit.variant_title}"
          loading="${loadingAttribute}" 
        />
        <div class="product--label-container">
          ${hit.tags
            .filter(tag => tag.startsWith('label-')) // Filter only the tags that start with "label-"
            .map(tag => html`
                <div class="ais-product-label ais-product-${tag.replace('% OFF', '').replace(' ', '-').trim().toLowerCase()}">${tag.replace('label-','')}</div>
              `)
            }
            
     <!-- %OFF sale label -->
     ${hit.sale_label
        ? html`<div class="ais-product-label product--label_sale_percent product--label_sale_percent-${hit.sale_label.replace('% OFF', '').trim()}">${hit.sale_label}</div>`
        : ''}
        </div>

        <button aria-label="Add to Wishlist" data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_${hit.id}" data-swaction="addToWishlist" data-product-id="${hit.id}" data-variant-id="${hit.objectID}" data-product-url="https://www.rmsbeauty.com${algoliaShopify.helpers.instantsearchLink(hit)}"></button>
        </div>

        <div class="ais-hit--details">
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              title="${algoliaShopify.helpers.fullTitle(hit.title,hit._distinct,hit.variant_title)}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>
          
          <p
            class="ais-hit--subtitle"
            title="${hit.product_type}${algoliaShopify.translation_helpers.by(hit.vendor)}"
            style="display:none;"
          >
            ${components.Highlight({ attribute: 'product_type', hit })}
            ${hit.vendor &&
              html`
                <span> ${algoliaShopify.translations.by} </span>
              `}
            ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
          </p>

          <div class="ais-product--rating">
          <div class="yotpo-widget-instance" data-yotpo-instance-id="347481" data-yotpo-product-id="${hit.id}" data-yotpo-cart-product-id="${hit.id}" data-yotpo-section-id="collection"></div>
          </div>
          
          <p class="ais-hit--price">
  ${algoliaShopify.helpers.displayPrice(hit, hit._distinct).includes('-') 
    ? html`
        <span class="product--from" data-item="nav-text">From</span>
        ${algoliaShopify.helpers.displayPrice(hit, hit._distinct).split('-')[0].trim()}
      `
    : algoliaShopify.helpers.displayPrice(hit, hit._distinct).trim()}

               <span class="ais-hit--price-striked ${!hit.compare_at_price ? 'no-compare-price' : ''}">
                 <span>
                ${algoliaShopify.helpers.displayStrikedPrice(
                      hit.price,
                      hit.compare_at_price
                    )}
                    </span>
                  </span>

                  <span class="ais-hit--price-discount">
                ${algoliaShopify.helpers.displayDiscount(
                    hit.price,
                    hit.compare_at_price,
                    hit.price_ratio
                  )}
                </span>
          </p>

          <p class="ais-ItemContentCta ${hit.tags.includes('coming-soon') ? 'coming-soon' : (hit.variants_inventory_count <= 0 ? 'out-of-stock' : '')}">
             ${option_name}
          </p>
        </div>
      </div>
      </a>
      </div>
    `;
    
  });
// Product Template - end

//Load Yotpo star rating widget on PLP
document.addEventListener('algolia.instantSearch.onRender', function() {
  if (typeof yotpoWidgetsContainer !== 'undefined' && yotpoWidgetsContainer.initWidgets) {
  yotpoWidgetsContainer.initWidgets();
  }
});

// InstantSearch hooks - end

// Insights hooks
// Changes the CSS selector for the add-to-cart button
algoliaShopify.hooks.registerHook('beforeAddToCartSelectorString', function(_selector) {
    // The default selector is '[name="add"]'
    // Return a CSS selector
    return '.product-buy-buttons--cta';
});

});
// Algolia Advanced customization - Custom Hooks - END

document.addEventListener('DOMContentLoaded', function() {
  
setTimeout(() => {

// search page facets buttons - begin
const collapsibleToggles = document.querySelectorAll('.collapsible-toggle');

collapsibleToggles.forEach(toggle => {
  toggle.addEventListener('click', function() {
    
    // Remove 'expanded' class from other dropdowns
    collapsibleToggles.forEach(otherToggle => {
      if (otherToggle !== this) {
          const wrapper = otherToggle.closest('.ais-facet-dropdown-wrapper');
          if (wrapper) {
          wrapper.classList.remove('expanded');
          }
      }
    });

  // Toggle 'expanded' class on the clicked dropdown
  const currentWrapper = this.closest('.ais-facet-dropdown-wrapper');
 if (currentWrapper) {
    currentWrapper.classList.toggle('expanded');
 }
    
});
});

// Get all dropdown wrappers
const dropdownWrappers = document.querySelectorAll('.ais-facet-dropdown-wrapper');

document.addEventListener('click', function(e) {
let clickedInsideDropdown = false;

// Check if the click is inside any dropdown
dropdownWrappers.forEach(wrapper => {
  if (wrapper.contains(e.target)) {
    clickedInsideDropdown = true;
  }
});

// If not clicked inside a dropdown, remove the 'expanded' class
if (!clickedInsideDropdown) {
  dropdownWrappers.forEach(wrapper => {
      wrapper.classList.remove('expanded');
  });
}
});
// search page facets buttons - end

}, 400);

});

// collection Algolia hitsList promo banner - begin

let hitsList;
let bannerSrc = null;
let bannerLink = null;

const metafieldsScript = document.querySelector('.collection-metafields-json');

if (metafieldsScript) {
  
if (window.matchMedia('(min-width: 900px)').matches) {
  document.querySelector('#algolia-shopify-instantsearch').style.visibility = 'hidden';
}
  
  const metafieldsData = JSON.parse(metafieldsScript.textContent);

  if (metafieldsData.length > 0) {
    bannerSrc = metafieldsData[0]?.banner || null;
    bannerLink = metafieldsData[1]?.['banner-link'] || null;
  }
}

const awaitHitsList = setInterval(() => {
  hitsList = document.querySelector('.ais-Hits-list');

if (hitsList) {
  clearInterval(awaitHitsList);
  console.log('Algolia hitsList loaded on DOM.')

if (hitsList && bannerSrc && bannerLink) {
  const bannerItem = document.createElement('li');
  bannerItem.classList.add('ais-Hits-item', 'collection-promo--root');
  
  bannerItem.innerHTML = `
      <a href="${bannerLink}" class="collection-promo--cover-link">
        <img src="https:${bannerSrc}" alt="Banner Image" class="banner-image" loading="eager" />
      </a>
  `;
  
  hitsList.insertBefore(bannerItem, hitsList.firstChild);
}
    
document.querySelector('#algolia-shopify-instantsearch').style.visibility = 'visible';
}
  
}, 100);
// collection Algolia hitsList promo banner - end

  
document.addEventListener('algolia.hooks.initialize', function() {

  algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', 

    function(defaultFilter) {

      if (defaultFilter && defaultFilter.includes("collection_ids")) {

        const collectionIDFilterRegex = /collection_ids:"\w+"/g;

        const matches = window.location.pathname.match(

          /\/collections\/([^/]+)/i

        );

        const collectionHandle = (matches && matches.length === 2) 

          ? matches[1] : null;




        if (collectionHandle) {

          return defaultFilter.replace(

            collectionIDFilterRegex, "collections:" + collectionHandle

          );

        }

      }

      return defaultFilter;

    }

  );

});




